import React from 'react';
import { Button } from '@hallmark/web.core.buttons.button';
import { InlineSVG } from '@hallmark/web.core.display.inline-svg';
import { Typography, TypographyVariants } from '@hallmark/web.core.typography.typography';
import { ObjectOrderProps } from '../font-drawer-types';
import styles from '../font-drawer.module.scss';
import { SendToBackSVG, BringToFrontSVG } from '../utils/svg';

export const ObjectOrder = ({
  onBringToFront,
  onSendToBack,
  bringToFrontLabel,
  sendToBackLabel,
}: ObjectOrderProps): React.ReactElement => {
  return (
    <div className={styles['object-order']}>
      <Button testId="bring-to-front" addClass={styles['object-order-button']} click={onBringToFront}>
        <InlineSVG
          path={BringToFrontSVG}
          title="Bring To Front"
          description="Bring To Front icon"
          role="img"
          testId="bring-to-front-svg"
          height={64}
        />
        <Typography variant={TypographyVariants.Body}>{bringToFrontLabel}</Typography>
      </Button>

      <Button testId="send-to-back" addClass={styles['object-order-button']} click={onSendToBack}>
        <InlineSVG
          path={SendToBackSVG}
          title="Send To Back"
          description="Send To Back icon"
          role="img"
          testId="send-to-back-svg"
          height={64}
        />
        <Typography variant={TypographyVariants.Body}>{sendToBackLabel}</Typography>
      </Button>
    </div>
  );
};
